import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;

  &.no-margin {
    margin-top: 0;
  }

  .ant-avatar {
    border: 1px solid #e9e9e7;
  }

  .ant-col {
    padding: 0 4px !important;

    .title {
      color: var(--primary-color);
    }
  }
`;
